import Consultation, { ConsultationState } from '~models/consultation'

import { useSuspenseInfiniteQuery } from '@tanstack/react-query'

import AppDataRepository from '~repositories/impl/app-data-repository'
import { APP_QUERY_KEYS } from './query-keys'

const useMyConsultations = ({ states }: ConsultationState) => {
  return useSuspenseInfiniteQuery<Paging<Consultation.Level1>, Error>({
    queryKey: APP_QUERY_KEYS.myConsultations(states || []),
    queryFn: ({ pageParam }) =>
      AppDataRepository.getPagedMyConsultations({
        pagination: 1,
        per_page: 5,
        states: states,
        cursor:
          typeof pageParam === 'string' && pageParam.length
            ? decodeURIComponent(pageParam)
            : pageParam,
      }),
    initialPageParam: undefined,
    getNextPageParam: lastPage =>
      lastPage.next ? lastPage.next.split('cursor=')[1].split('&')[0] : null,
  })
}

export default useMyConsultations
